export { default } from './Unstable_TrapFocus';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/index.js
// module id = 821
// module chunks = 0